export const selectPredictions = (state) => state.predictions.all || [];
export const selectCurrentPrediction = (state) =>
  state.predictions?.current || null;
export const selectIsLoading = (state) => state.predictions.isLoading;
export const selectLastPrediction = (state) => state.predictions.last || null;
export const selectPredictionCount = (state) => state.predictions.count || 0;
export const selectPredictionCounts = (state) => state.predictions.counts || null;
